import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getNOCDashboardReducer (state: RootState): AcNOCDashboardState {
  return state.acnocDashboardReducer
}
